module.exports = __webpack_public_path__ + "img/Weilin Vision Software.9a1ec4dd.jpg";